module.exports = __webpack_public_path__ + "70967f470219ccbe193dbd1c7da5a4ad.jpg";